module.exports = __webpack_public_path__ + "static/media/main17.441de98d.png";